import { Box, List, ListItem, Typography, Stack, Switch } from '@mui/material';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { savePreferences } from '../../SetUp/actions';
import { myPreferences } from '../../../DataAccessLayer/services';
import { connect } from 'react-redux';
import { putData } from '../../../DataAccessLayer';
import { getUser } from '../../Layout/utils';
class General extends Component {
  state = {
    // activeTab: 1
    isUserPhoto: false,
  };

  toggleShowingPhoto = () => {
    this.setState({ isUserPhoto: !this.state.isUserPhoto }, () => {
      const preferences = {
        ...this.props.preferences,
        DisplayOptions: {
          ...this.props.preferences.DisplayOptions,
          Options: {
            ...this.props.preferences.DisplayOptions.Options,
            isUserPhoto: this.state.isUserPhoto,
          },
        },
      };

      putData(myPreferences, {
        preferences,
        midas: this.props.isImpersonating ? this.props.impersonation.midas : this.props.user.midas,
      })
        .then((_) => {
          this.props.savePreferences(preferences);
        })
        .catch((err) => console.log(err));
    });
  };

  //Θ(1) Sets active tab
  // onTabChange = (e, activeTab) => {
  //     this.setState({activeTab});
  // };

  componentDidMount() {
    this.setState({ isUserPhoto: this.props.isUserPhoto });
  }

  render() {
    const { isUserPhoto } = this.state;

    const user = getUser(this.props.user, this.props.impersonation);

    return (
      <Box className="wrapper general">
        <Typography component={'h3'} className="sr-only visibility-hidden">
          General Settings
        </Typography>

        <Stack direction="row" spacing={3}>
          <Typography component="h3">Navigation</Typography>
          <Stack>
            {/* //TODO: need to update css so the on state is pretty */}
            <Stack direction="row" sx={{ mb: 2, mt: 1 }}>
              <Typography>Show Photo</Typography>
              <Switch
                id="settings_general_switch_togglePhoto"
                size="small"
                color="primary"
                checked={!isUserPhoto}
                onChange={() => this.toggleShowingPhoto()}
                aria-labelledby="Show photo or initials"
                inputProps={{
                  'aria-labelledby': 'Show photo or initials',
                }}
              />
              <Typography>Show Initials</Typography>
            </Stack>

            <Typography component={'p'} className="small">
              The photo used in the navigation pane is from the University ID system and is
              displayed only to you. To change the photo used in the Portal, you must change the
              photo in the University ID system:
            </Typography>
            <ol>
              <li>
                {/* //TODO: add actual name and UIN to string */}
                Email the Card Center at{' '}
                <a
                  href={`mailto:cardCenter@odu.edu?subject=Update University ID Photo&body=Please update my University ID photo with the attached photograph.  Name - ${user.displayName} UIN - [UIN Here] Thank You.`}
                >
                  cardCenter@odu.edu
                </a>
                .
              </li>
              <li>Include your name and your University Identification Number (UIN).</li>
              <li>
                Attach a new photograph (headshot, solid-colored background, forward facing and no
                one else in the picture ).
              </li>
            </ol>

            <Typography component={'p'}>
              Once your photo is approved, it'll be updated in the University ID system and show up
              in the Portal and on your electronic University ID app. Charges apply only if you
              would like a new printed ID card.
            </Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  preferences: state.preferencesReducer.preferences,
  user: state.AWSReducer.user,
  isImpersonating: state.impersonationReducer.impersonation?.isImpersonating ?? false,
  impersonation: state.impersonationReducer.impersonation,
  isUserPhoto: state.preferencesReducer.preferences.DisplayOptions?.Options?.isUserPhoto ?? false,
});

const mapDispatchToProps = {
  savePreferences,
};

export default connect(mapStateToProps, mapDispatchToProps)(General);
